import 'assets/styles/custom.scss'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
// // fonts
// import "assets/fonts/sf-pro-fonts/SFPRODISPLAYBOLD.OTF"
// import "assets/fonts/sf-pro-fonts/SFPRODISPLAYREGULAR.OTF"
// style
// bootstrap
import 'bootstrap/dist/css/bootstrap.min.css'
// keen
import 'assets/styles/keen/theme01/plugins.bundle.css'
import 'assets/styles/keen/theme01/style.bundle.css'
// app custom style
import 'assets/styles/app.style.scss'
import './index.css'
// react-datepicker
import 'react-datepicker/dist/react-datepicker.css'
// i18
import i18n from 'i18n'
import { I18nextProvider } from 'react-i18next'
// redux
import store from 'app/store'
import { Provider as ReduxProvider } from 'react-redux'
// tanstack query
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { ConfigProvider } from 'antd'
import queryClient from 'api/queryClient'
import { ColumnsProvider } from 'features/TemplateInvoice/screens/CreateTemplateInvoice/ColumnsContext'
import { SubColumnsProvider } from 'features/TemplateInvoice/screens/CreateTemplateInvoice/SubColumnsContext'
import { customTheme } from 'general/utils/CustomAntTheme'
import { HostnameProvider } from 'general/context/HostnameContext'

// if (process.env.REACT_APP_WIDGETUID) {
//   window.AMIS_CHAT_CONFIG = {
//     widgetUid: process.env.REACT_APP_WIDGETUID,
//     showToggleButton: true,
//     // position: {
//     //   bottom: '30px',
//     //   right: '10px',
//     // },
//   }
//   const scripts = [
//     'https://widget.icorp.vn/suport-widget.js',
//     'https://widget.icorp.vn/purchase-widget.js',
//     'https://widget.icorp.vn/widget.js',
//   ]
//   // const scripts = [
//   //   'https://widget.icorp.vn/hotline-widget.js',
//   //   'https://widget.icorp.vn/widget.js',
//   //   'https://widget.icorp.vn/purchase-widget.js',
//   // ]
//   scripts.forEach((src) => {
//     const script = document.createElement('script')
//     script.src = src
//     script.async = true
//     document.body.appendChild(script)
//   })
// }

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <ReduxProvider store={store}>
    <QueryClientProvider client={queryClient}>
      <I18nextProvider i18n={i18n}>
        <BrowserRouter>
          <ColumnsProvider>
            <SubColumnsProvider>
              <HostnameProvider>
                <ConfigProvider theme={customTheme}>
                  <App />
                </ConfigProvider>
              </HostnameProvider>
            </SubColumnsProvider>
          </ColumnsProvider>
        </BrowserRouter>
      </I18nextProvider>
      <div style={{ fontSize: '15px' }}>
        <ReactQueryDevtools
          initialIsOpen={false}
          buttonPosition="bottom-left"
          client={queryClient}
        />
      </div>
    </QueryClientProvider>
  </ReduxProvider>,
)
